import { Flippable } from './Flippable'

export default Flippable
